import { render, staticRenderFns } from "./VasionRename.vue?vue&type=template&id=0f59b246&scoped=true"
import script from "./VasionRename.vue?vue&type=script&lang=js"
export * from "./VasionRename.vue?vue&type=script&lang=js"
import style0 from "./VasionRename.vue?vue&type=style&index=0&id=0f59b246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59b246",
  null
  
)

export default component.exports